import styled from 'styled-components';
import { colors } from '../../styles/tokens';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;

  min-height: 60vh;
  padding: 80px 24px;
  text-align: center;
  color: ${colors.onSurfaceVariant};
`;

export const Title = styled.h2`
  color: ${colors.onSurface};
  font-size: 20px;
  font-weight: 800;
`;

export const Subtitle = styled.p`
  font-size: 14px;
  max-width: 420px;
`;
